import type { GenericObject } from "@/common/interfaces/IGeneric"
import i18n from "@/i18n"
import { ASSET_PROVISION_FORM_DATA } from "@/common/constants/provideData"
export interface IntStateData<T = any> {
  data: T[]
  isLoading: boolean
  selectedData: T[] | null
  isDisabled?: boolean
}

export interface IntProviderState {
  offerCategories: IntStateData
  aspects: IntStateData
  models: IntStateData
  useCases: IntStateData
  allActiveUseCases: IntStateData
  assetProvisionForm: GenericObject
  digitalTwinTypes: IntStateData
  aspectsCountData: number
  connectorCountData: number
}

export const getDefaultState = (): IntProviderState => {
  return {
    offerCategories: {
      data: [
        {
          id: "provide",
          title: i18n.global.t("wizardSelectionPopup.provide"),
          icon: '<scale-icon-action-upload-to-cloud accessibility-title="upload-to-cloud"/>'
        },
        {
          id: "consume",
          title: i18n.global.t("wizardSelectionPopup.consume"),
          icon: '<scale-icon-content-shop accessibility-title="shop"/>'
        },
        {
          id: "govern",
          title: i18n.global.t("wizardSelectionPopup.govern"),
          icon: '<scale-icon-user-file-admin accessibility-title="admin"/>'
        }
      ],
      isLoading: false,
      selectedData: null
    },
    aspects: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    models: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    useCases: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    allActiveUseCases: {
      data: [],
      isLoading: false,
      selectedData: null
    },
    digitalTwinTypes: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    assetProvisionForm: ASSET_PROVISION_FORM_DATA,
    aspectsCountData: 0,
    connectorCountData: 0
  }
}
